import { Component, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'app-switch-toggle',
    templateUrl: './switch-toggle.component.html',
    styleUrls: ['./switch-toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchToggleComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SwitchToggleComponent implements ControlValueAccessor {
  public checkedControl = new FormControl<boolean>(true);

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {}

  writeValue(value?: boolean): void {
    this.checkedControl.setValue(value ?? false);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggle() {
    const checked = !this.checkedControl.value;

    this.checkedControl.setValue(checked);
    this.onChange(checked);
  }
}
